import { AlertTriangle, X, ChevronDown } from 'lucide-react';
import { useContext, useState } from 'react';
import AppContext from '../../../../../context/AppContext';

const DISPUTE_CATEGORIES = [
  'Work Not Completed',
  'Poor Quality Work',
  'Worker Arrived Late',
  'Unprofessional Behavior',
  'Property Damage',
  'Other',
];

const DisputeModal = ({ onClose, job, success, onSubmit, loading }) => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  return (
    <div className="mjobs-modal-overlay">
      <div className="mjobs-dispute-modal" onClick={e => e.stopPropagation()}>

        <div className="mjobs-dispute-modal__header">
          <div className="mjobs-dispute-modal__icon">
            <AlertTriangle size={20} />
          </div>
          <div>
            <h4 className="mjobs-dispute-modal__title">Raise a Dispute</h4>
            <p className="mjobs-dispute-modal__sub">Tell us what went wrong</p>
          </div>
          <button className="mjobs-dispute-modal__close" onClick={onClose}><X size={16} /></button>
        </div>

        <div className="mjobs-dispute-modal__body">
          {/* Category */}
          <div className="mjobs-dispute-modal__field">
            <label>Issue Category</label>
            <div className="mjobs-dispute-modal__select-wrap">
              <select
                value={category}
                onChange={e => setCategory(e.target.value)}
              >
                <option value="">Select an issue...</option>
                {DISPUTE_CATEGORIES.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
              <ChevronDown size={15} className="mjobs-dispute-modal__chevron" />
            </div>
          </div>

          {/* Description */}
          <div className="mjobs-dispute-modal__field">
            <label>Description</label>
            <textarea
              placeholder="Describe your issue in detail..."
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={4}
            />
          </div>
        </div>

        <div className="mjobs-dispute-modal__footer">
          <button className="mjobs-dispute-modal__cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="mjobs-dispute-modal__submit-btn"
            onClick={(e) =>
              onSubmit(
                e,
                onClose,
                success,
                job,
                category,
                description
              )
            }
            disabled={!category || !description.trim() || loading}
          >
            {loading ? (
              <span className="mjobs-spinner" />
            ) : (
              <>
                <AlertTriangle size={14} /> Submit Dispute
              </>
            )}
          </button>
        </div>

      </div>
    </div>
  );
};

export default DisputeModal;